import { render, staticRenderFns } from "./editVehicle.vue?vue&type=template&id=4420cf7a&"
import script from "./editVehicle.js?vue&type=script&lang=js&"
export * from "./editVehicle.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports